import { GoRocket } from "react-icons/go";

export default function AssignmentLeftControls() {
    return (
        <div className="d-flex">
            <GoRocket className="fs-4 mx-4" style={{color: "green"}} />
        </div>
    );
}
